import { BackgroundColor } from '@ampcore/ampcom-contracts'

export const promoBackgroundColors = [
  BackgroundColor.STONE,
  BackgroundColor.MINT_TINT,
  BackgroundColor.LIME_TINT,
  BackgroundColor.PURPLE_TINT,
  BackgroundColor.BERRY_TINT,
  BackgroundColor.ORANGE_TINT,
  BackgroundColor.TRANSPARENT
] as const

export type PromoBackgroundColor = (typeof promoBackgroundColors)[number]
